<template>
    <section>
        <div class="container container--fluid">
            <v-card>
                <v-card-title class="headline">
                    {{$t('connectors_title')}}
                    <v-spacer></v-spacer>
                    <v-btn
                            small
                            color="primary"
                            class="white--text"
                            @click="showForm()"
                            v-if="userCan('connectors_create')"
                    >
                        {{$t('create')}}
                        <v-icon right dark>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn
                            icon
                            small
                            @click="fetch()"
                    >
                        <v-icon right dark>mdi-reload</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-subtitle>{{$t('connectors_subtitle')}}</v-card-subtitle>
                <v-divider></v-divider>
                <v-data-table  class="text-capitalize" :headers="headers" :items="items" :loading="loading">
                    <template #item.code="{item}">
                        <code>{{item.code}}</code>
                    </template>
                    <template #item.last_registered_at="{item}">
                        {{ getJalaliDate(item.last_registered_at * 1000) }}
                    </template>
                    <template #item.last_paid_at="{item}">
                        {{ getJalaliDate(item.last_paid_at * 1000) }}
                    </template>
                    <template #item.created_at="{item}">
                        {{ getJalaliDate(item.created_at * 1000) }}
                    </template>
                    <template #item.updated_at="{item}">
                        {{ getJalaliDate(item.updated_at * 1000) }}
                    </template>
                    <template #item.actions="{item}">
                        <v-tooltip top v-if="userCan('connectors_update')">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small @click="showForm(item)" v-bind="attrs" v-on="on">
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                            <span>{{$t('edit')}}</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
            <Form
                    v-if="item"
                    :item="item"
                    @close="item = null"
                    @submit="fetch"
            ></Form>
        </div>
    </section>
</template>

<script>
    import RequestList from "../services/RequestList";
    import Service from "../services/ConnectorsService";
    import Form from "../components/ConnectorForm";

    import config from "@/config";
    export default {
        components : {
            Form
        },
        computed: {
        },
        watch: {
            dialog (val) {
                !val && this.close()
            },
            '$route'(){
                this.fetch();
            },
            options: {
                handler(options) {
                    let query = Object.assign(JSON.parse(JSON.stringify(this.$route.query)),{
                        page: options.page,
                        count : options.itemsPerPage
                    });

                    this.$router.push({
                        query : query
                    }).catch(err => err);
                },
                deep: true,
            }
        },
        data() {
            return {
                item : null,
                loading : false,
                headers : [
                    {
                        text: this.$t('id'),
                        value: 'id',
                    },
                    {
                        text: this.$t('caption'),
                        value: 'caption',
                    },
                    {
                        text: this.$t('connector_code'),
                        value: 'code',
                    },
                    {
                        text: this.$t('total_registered_user'),
                        value: 'total_registered_user',
                    },
                    {
                        text: this.$t('last_registered_at'),
                        value: 'last_registered_at',
                    },
                    {
                        text: this.$t('total_paid_user'),
                        value: 'total_paid_user',
                    },
                    {
                        text: this.$t('last_paid_at'),
                        value: 'last_paid_at',
                    },
                    {
                        text: this.$t('created_at'),
                        value: 'created_at',
                    },
                    {
                        text: this.$t('updated_at'),
                        value: 'updated_at',
                    },
                    {
                        text: this.$t('action'),
                        value: 'actions',
                    }
                ],
                options: {
                    page : 1,
                    itemsPerPage : config.itemsPerPage
                },
                items : [],
                total : 0,
                page : 1,
                footerProps: {'items-per-page-options': [5, 10,15, 30, 50, 100]}
            }
        },
        mounted() {
            this.fetch();
        },
        methods: {
            async fetch() {
                this.loading = true;
                this.options.page = parseInt(this.$route.query.page || this.options.page);
                this.options.itemsPerPage = parseInt(this.$route.query.count || this.options.itemsPerPage);

                let requestList = new RequestList();

                requestList.setFilters(this.$route.query.filters || []);
                requestList.addOrder('id','desc');
                requestList.setPage(this.options.page, this.options.itemsPerPage);

                try {
                    let {data} = await Service.list(requestList);
                    this.items = data.value.connectors;
                    this.total = data.value.total;
                } finally {
                    this.loading = false;
                }
            },
            showForm(item) {
                item = item || Service.getDefault();
                this.item = item;
            }

        }
    }
</script>